export default "__VITE_ASSET__VNyBAzzB__"